export const ASSESSMENT_TYPES = [
  { label: "Data Engineering",  value: "Data_Engineering" },
  { label: "Power BI",          value: "Data_Analytics_PowerBI" },
  { label: "Data Science",      value: "AI_ML_DataScience" },
  { label: "Web Application",   value: "Web_Applications" },
];